module.exports = __webpack_public_path__ + "static/media/img2-1.0cdc318e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_suelo/CA/img2-1.png
// module id = 1317
// module chunks = 3